const ClubContactDetailPageReducer = (state, action) => {
  switch (action.type) {
    case 'CLUB_CONTACT_DETAIL_FETCHING':
      return {...state, isFetching: true};
    case 'CLUB_CONTACT_DETAIL_UPDATE':
      return {...state, isFetching: false, contact: action.data};
    default:
      return state;
  }
};

export {ClubContactDetailPageReducer};
